import React, { useEffect, useState } from 'react';
import CancelSvg from 'assets/icons/cancel.svg';
import { Button } from 'components/common';

interface AddFeatureProps {
  showModal: boolean;
  setShowModal: any;
  items: object[];
  setItems: any;
}

const AddFeatureModal = ({
  showModal,
  setShowModal,
  items,
  setItems,
}: AddFeatureProps) => {
  const defaultItem = {
    key: '',
    value: '',
  };
  const [newItems, setNewItems] = useState<any[]>([defaultItem]);

  useEffect(() => {
    if (items.length) {
      setNewItems(items);
    } else {
      const value = [defaultItem];
      setNewItems(value);
    }
  }, [items]);

  const handleAddItem = () => {
    const hhhh = [...newItems];
    hhhh.push(defaultItem);
    setNewItems(hhhh);
  };

  const handleRemoveItem = (index: any) => {
    const hhh = [...newItems];
    const newHhh = hhh.filter((values, ind) => ind !== index);
    setNewItems(newHhh);
  };

  const handleOnChangeOfItemKey = (value: string, index: number) => {
    const hhh = [...newItems];
    hhh[index].key = value;
    setNewItems(hhh);
  };

  const handleOnChangeOfItemValue = (value: string, index: number) => {
    const hhh = [...newItems];
    hhh[index].value = value;
    setNewItems(hhh);
  };

  const handleSubmit = () => {
    setItems(newItems);
    setShowModal(false);
  };

  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-xl">
              <div className="bg-gray-4 border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-white text-2xl font-semibold">
                    Input properties
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-white opacity-70 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      X
                    </span>
                  </button>
                </div>

                <div className="relative p-6 flex-auto">
                  {newItems.map(({ key, value }: any, index) => (
                    <div className="flex mt-2">
                      <div
                        role="button"
                        aria-hidden="true"
                        onClick={(e) => {
                          e.preventDefault();
                          handleRemoveItem(index);
                        }}
                        onKeyDown={(e) => {
                          e.preventDefault();
                          handleRemoveItem(index);
                        }}
                        className="border border-primary-2 rounded-l-md mr-2 p-2 cursor-pointer"
                      >
                        <img src={CancelSvg} alt="cancel" />
                      </div>
                      <input
                        value={key}
                        onChange={(e) => {
                          handleOnChangeOfItemKey(e.target.value, index);
                        }}
                        className="bg-transparent text-white border border-primary-2 p-2 mr-2 rounded-r-md"
                        placeholder="Key"
                      />
                      <input
                        value={value}
                        onChange={(e) => {
                          handleOnChangeOfItemValue(e.target.value, index);
                        }}
                        className="bg-transparent text-white border border-primary-2 p-2 rounded-r-md"
                        placeholder="Value"
                      />
                    </div>
                  ))}

                  <div className="mt-4">
                    <Button
                      className=""
                      type="button"
                      variant="outline-primary"
                      onClick={handleAddItem}
                    >
                      Add More
                    </Button>
                  </div>
                </div>

                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleSubmit}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </>
      ) : null}
    </>
  );
};

export default AddFeatureModal;
